<template>
  <div
    class="flex flex-row items-center gap-2 rounded-lg border border-primary bg-white px-2 py-1 shadow-sm"
  >
    <UserAvatar
      :user-id="user.id"
      size="small"
      :disponibility="user.disponibility?.assignement_status"
      hide-status
      flat
    />
    <div class="flex flex-col leading-none">
      <span class="text-sm font-semibold">{{ user.full_name }}</span>
      <span v-if="assignedFunction" class="text-xs opacity-70">
        {{ assignedFunction.name }}
      </span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import UserAvatar from '@c/Avatar/UserAvatar.vue'

export default defineComponent({
  name: 'AssignedUserCard',
  components: { UserAvatar },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      assignedPersonFunctions: 'metadata/getAssignedPersonFunctionsMetadata'
    }),
    assignedFunction() {
      return this.assignedPersonFunctions.find(
        (f) => f.id === this.user.disponibility?.function
      )
    }
  }
})
</script>
